var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "edit-multi-record" },
    [
      _c(
        "a-steps",
        { attrs: { current: _vm.currentStep } },
        [
          _c("a-step", { attrs: { title: "Select Field" } }),
          _vm._v(" "),
          _c("a-step", { attrs: { title: "Update Value" } }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "step-content" }, [
        _vm.currentStep === 0
          ? _c("div", [
              _c("p", [_vm._v(_vm._s(_vm.$t("tables.pleaseUpdateSelected")))]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "field-list" },
                _vm._l(_vm.getEditableFields(), function (field) {
                  return _c(
                    "div",
                    {
                      key: field._id,
                      staticClass: "field-item",
                      class: { selected: _vm.selectedField === field },
                      on: {
                        click: function ($event) {
                          _vm.selectedField = field
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "field-icon" },
                        [
                          _c("FieldIcon", {
                            attrs: {
                              type: field.fieldType,
                              defaultIcon: field.icon,
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "field-name" }, [
                        _vm._v(_vm._s(field.name)),
                      ]),
                    ]
                  )
                }),
                0
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.currentStep === 1
          ? _c(
              "div",
              [
                _c("p", [
                  _vm._v(_vm._s(_vm.$t("tables.pleaseSelectedNewValue"))),
                ]),
                _vm._v(" "),
                ["text", "long-text", "email", "url", "phone"].includes(
                  _vm.selectedField.fieldType
                )
                  ? _c("a-input", {
                      model: {
                        value: _vm.fieldValue,
                        callback: function ($$v) {
                          _vm.fieldValue = $$v
                        },
                        expression: "fieldValue",
                      },
                    })
                  : ["number", "currency"].includes(_vm.selectedField.fieldType)
                  ? _c("a-input-number", {
                      model: {
                        value: _vm.fieldValue,
                        callback: function ($$v) {
                          _vm.fieldValue = $$v
                        },
                        expression: "fieldValue",
                      },
                    })
                  : _vm.selectedField.fieldType === "datetime"
                  ? _c("a-date-picker", {
                      model: {
                        value: _vm.fieldValue,
                        callback: function ($$v) {
                          _vm.fieldValue = $$v
                        },
                        expression: "fieldValue",
                      },
                    })
                  : _vm.selectedField.fieldType === "dropdown"
                  ? _c("CustomPicker", {
                      attrs: {
                        items: _vm.selectedField.options.dropdown.options,
                        multiple: _vm.selectedField.options.dropdown.multiple,
                        idKey: "value",
                        labelKey: "value",
                      },
                      model: {
                        value: _vm.fieldValue,
                        callback: function ($$v) {
                          _vm.fieldValue = $$v
                        },
                        expression: "fieldValue",
                      },
                    })
                  : _vm.selectedField.fieldType === "checkbox"
                  ? _c("a-switch", {
                      model: {
                        value: _vm.fieldValue,
                        callback: function ($$v) {
                          _vm.fieldValue = $$v
                        },
                        expression: "fieldValue",
                      },
                    })
                  : _c("a-input", {
                      model: {
                        value: _vm.fieldValue,
                        callback: function ($$v) {
                          _vm.fieldValue = $$v
                        },
                        expression: "fieldValue",
                      },
                    }),
              ],
              1
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "action-buttons" },
        [
          _c("a-button", { on: { click: _vm.handleCancel } }, [
            _vm._v(_vm._s(_vm.$t("table.cancel"))),
          ]),
          _vm._v(" "),
          _c(
            "a-button",
            {
              attrs: {
                type: "primary",
                disabled: _vm.currentStep === 0 && !_vm.selectedField,
              },
              on: { click: _vm.handleNext },
            },
            [
              _vm._v(
                "\n            " +
                  _vm._s(
                    _vm.currentStep === 0
                      ? _vm.$t("table.next")
                      : _vm.$t("table.save")
                  ) +
                  "\n        "
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }